import { ListItem } from '@mui/material';
import PropTypes from 'prop-types';

import { TextWrapper, WrapperIconText } from './TrlSearch.styles';

export const TrlSearchItems = ({
  option,
  leftSlot,
  rightSlot,
  uppercaseLetters,
  hasLeftStraip,
  ...props
}) => (
  <ListItem {...props}>
    {leftSlot}
    <WrapperIconText title={option.label} hasLeftStraip={hasLeftStraip}>
      <TextWrapper uppercaseLetters={uppercaseLetters}>
        {option.label}
      </TextWrapper>
    </WrapperIconText>
    {rightSlot}
  </ListItem>
);

TrlSearchItems.propTypes = {
  option: PropTypes.object.isRequired,
  leftSlot: PropTypes.node,
  rightSlot: PropTypes.node,
  uppercaseLetters: PropTypes.bool,
  hasLeftStraip: PropTypes.bool,
};
